import { render, staticRenderFns } from "./orderCard.vue?vue&type=template&id=0fead8d8&scoped=true&"
import script from "./orderCard.vue?vue&type=script&lang=js&"
export * from "./orderCard.vue?vue&type=script&lang=js&"
import style0 from "./orderCard.vue?vue&type=style&index=0&id=0fead8d8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fead8d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fead8d8')) {
      api.createRecord('0fead8d8', component.options)
    } else {
      api.reload('0fead8d8', component.options)
    }
    module.hot.accept("./orderCard.vue?vue&type=template&id=0fead8d8&scoped=true&", function () {
      api.rerender('0fead8d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shop/orderList/component/orderCard.vue"
export default component.exports